export const SET_CART_LOADING = 'SET_CART_LOADING';
export const SET_LOCAL_CART = 'SET_LOCAL_CART';
export const SET_STORE_CART = 'SET_STORE_CART';
export const SET_LOCATION_ERR = 'SET_LOCATION_ERR';
export const CLEAR_CART = 'CLEAR_CART';
